export const PAGE_SIZE = 5;
export const MOBILE_OFFSET_SCROLL = 300;
export const DESKTOP_OFFSET_SCROLL = 260;
export const DATE_FORMAT = "ddd, MMM DD";
export const TIME_FORMAT = "h:mm A";
